/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_FormatInputs */

const en_dialog_format = /** @type {(inputs: Dialog_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format:`)
};

const es_dialog_format = /** @type {(inputs: Dialog_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato:`)
};

/**
* | output |
* | --- |
* | "Format:" |
*
* @param {Dialog_FormatInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_format = /** @type {((inputs?: Dialog_FormatInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_FormatInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_format(inputs)
	return en_dialog_format(inputs)
});